import { render, staticRenderFns } from "./SetBrandPrice.vue?vue&type=template&id=9719f59e&scoped=true&"
import script from "./SetBrandPrice.vue?vue&type=script&lang=js&"
export * from "./SetBrandPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9719f59e",
  null
  
)

export default component.exports